import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

const PageVisitIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 34 30" width="24px" fill={COLOR_TEXT_MAIN}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3V21H31V3H3ZM1 0C0.447715 0 0 0.447716 0 1V23C0 23.5523 0.447716 24 1 24H33C33.5523 24 34 23.5523 34 23V1C34 0.447715 33.5523 0 33 0H1Z"
      fill="#4C566C"
    />
    <rect x="13" y="24" width="8" height="3" fill="#4C566C" />
    <rect x="7" y="27" width="20" height="3" rx="1" fill="#4C566C" />
    <path
      d="M26.7429 19L21.8571 14.1143L20.4286 18.4286L17 7L28.4286 10.4286L24.1143 11.8571L29 16.7429L26.7429 19Z"
      fill="#4C566C"
    />
  </svg>
);

export default PageVisitIcon;
